<script>
/* eslint-disable no-console */
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {
      operating: 'EDIT',
    }
  },
  methods: {
    load() {
      var year =
        (this.$refs.calendar && this.$refs.calendar.year) ||
        this.$route.query.year
      var month =
        (this.$refs.calendar && this.$refs.calendar.month) ||
        this.$route.query.month
      this.loadDataByYearAndMonth(year, month)
    },

    loadDataByYearAndMonth(year, month) {
      var id = this.$route.query.id
      var companyId = this.$route.query.companyId
      var warehouseId = this.$route.query.warehouseId
      var buId = this.$route.query.buId
      var businessUnitId = this.$route.query.businessUnitId || ''
      if (!buId && companyId) {
        this.isSJL = true
        this.$http
          .get(
            `/warehouse-container-settings/${id}?warehouseId=${warehouseId}&buId=${companyId}&year=${year}&month=${month}`
          )
          .then((res) => {
            this.transferData(res.data)
          })
      } else {
        this.$http
          .get(
            `/warehouse-container-settings/${id}?warehouseId=${warehouseId}&buId=${buId}&businessUnitId=${businessUnitId}&year=${year}&month=${month}`
          )
          .then((res) => {
            if (
              this.settings.productGroups.length === 0 &&
              res.data.length === 0
            ) {
              this.settings = {
                companyId: companyId,
                warehouseId: warehouseId,
                buId: buId,
                businessUnitId: businessUnitId,
                productGroups: [],
              }
              this.loadProductGroups()
            } else {
              this.transferData(res.data)
            }
          })
      }
    },

    transferData(resultList) {
      this.settings = {
        warehouseId:
          this.settings.warehouseId ||
          (resultList[0] && resultList[0].warehouseId),
        buId: this.settings.buId || (resultList[0] && resultList[0].buId),
        businessUnitId:
          this.settings.businessUnitId ||
          (resultList[0] && resultList[0].businessUnitId),
        productGroup: this.settings.productGroup,
        productGroups: this.settings.productGroups || [],
      }
      if (!this.isSJL) {
        this.loadProductGroups()
      }
      var groupedDatas = this.groupedDatas(resultList)
      if (this.isSJL) {
        var SJLSetting = this.settings.productGroups.find(
          (d) => d.name === 'SJL'
        )
        if (!SJLSetting) {
          this.settings.productGroup = 'SJL'
          this.settings.productGroups.push({
            name: 'SJL',
            dailySettings: groupedDatas[0],
          })
        } else {
          if (groupedDatas && groupedDatas.length > 0) {
            groupedDatas[0].forEach((d) => {
              var existDaily = SJLSetting.dailySettings.find(
                (ds) => ds.date === d.date
              )
              if (!existDaily) {
                SJLSetting.dailySettings.push(d)
              } else {
                SJLSetting.upperLimit = d.upperLimit
                this.$refs.sjl[0].load()
              }
            })
          }
        }
      } else {
        groupedDatas.forEach((productGroupDatas) => {
          var productGroupData = { name: null, dailySettings: [] }
          productGroupDatas.forEach((p) => {
            if (!productGroupData.name) {
              productGroupData.name = p.productGroupName
            }
            productGroupData.dailySettings.push({
              date: p.date,
              upperLimit: p.upperLimit,
              id: p.id,
            })
          })

          var existSetting = this.settings.productGroups.find(
            (pg) => pg.name === productGroupData.name
          )

          if (existSetting) {
            productGroupData.dailySettings.forEach((d) => {
              var existDaily = existSetting.dailySettings.find(
                (ds) => ds.date === d.date
              )
              if (!existDaily) {
                existSetting.dailySettings.push(d)
              } else {
                existDaily.upperLimit = d.upperLimit
                this.$refs[this.settings.productGroup][0].load()
              }
            })
          } else {
            this.settings.productGroups.push(productGroupData)
          }
        })
      }
    },

    groupedDatas(data) {
      var a = this.groupBy(data, function (item) {
        return [item.productGroupName]
      })
      return a
    },

    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    },

    refresh(year, month) {
      this.loadDataByYearAndMonth(year, month)
    },

    loadProductGroups() {
      this.$http
        .get(
          `/product-groups/kv?buId=${this.settings.buId}&businessUnitId=${
            this.settings.businessUnitId ? this.settings.businessUnitId : ''
          }`
        )
        .then((res) => {
          this.productGroups = res.data
          console.log(this.settings)
          if (this.productGroups.length > 0) {
            var name = this.productGroups[0].value
            console.log(name)
            if (!this.settings.productGroup) {
              this.settings.productGroup = name
            }
            if (
              !this.settings.productGroups ||
              this.settings.productGroups.length === 0
            ) {
              this.settings.productGroups = [
                {
                  name: name || this.settings.productGroup,
                  dailySettings: [],
                },
              ]
            }
          }
        })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
